export default __webpack_public_path__ + "static/angie2-fba0b434f40d8f20f43d37d28af7edc4.jpg";